import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=b1964e82"
import script from "./NewComment.vue?vue&type=script&lang=ts"
export * from "./NewComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports